import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StyleDisplayDirective } from './style-display.directive';

@NgModule({
  declarations: [StyleDisplayDirective],
  imports: [CommonModule],
  exports: [StyleDisplayDirective]
})
export class StyleDisplayModule {}
